import Constants from './Constants'

export default {
  setAdShown () {
    localSetAdShown()
  },
  canShowAd () {
    if (!window.localStorage.getItem(`${Constants.APP_STORAGE_KEY}-interstialReady`)) {
      console.log('Ad not loaded, so can\'t show now')
      return false
    }
    if (!window.localStorage.getItem(`${Constants.APP_STORAGE_KEY}-adShown`)) {
      return true
    }
    let time = window.localStorage.getItem(`${Constants.APP_STORAGE_KEY}-adShown`)
    console.log(new Date().getTime() - time)
    return (new Date().getTime() - time) > Constants.AD_INTERVAL
  },
  randomColor () {
    return Math.floor(Math.random() * 16777215 / 2 + 888888).toString(16)
  },
  storeLocalData (key, data) {
    window.localStorage.setItem(`${Constants.APP_STORAGE_KEY}-${key}`, data)
  },
  getLocalData (key) {
    return window.localStorage.getItem(`${Constants.APP_STORAGE_KEY}-${key}`)
  },
  showBannerAd () {
    if (!window.cordova) return
    var options = {
      bannerid: '931260990742693_931271424074983',
      isTesting: false
    }
    window.cordova.plugins.codeplayfacebookads.loadAndShowBannerAds(options, result => {
      console.log('Ad shown succesfully', result)
    }, result => {
      console.log('Failed to show ad ' + result)
    })
  },
  hideBannerAd (callback) {
    if (!window.cordova) return
    window.cordova.plugins.codeplayfacebookads.hideBannerAds('', result => {
      console.log('Ad hidden succesfully')
      callback()
    }, result => {
      callback()
    })
  },
  loadInterstitialAds () {
    localLoadInterstialAds()
  },
  showInterstitialAd () {
    if (window.cordova) {
      window.cordova.plugins.codeplayfacebookads.showInterstitialAds(interstitialSuccess, interstitialFail)
    }
    function interstitialSuccess (event) {
      console.log('showAd callback', event)
    }
    function interstitialFail (error) {
      console.log('show interstitial error callback', error)
    }
  },
  downloadFile (dataurl, filename) {
    const link = document.createElement('a')
    link.href = dataurl
    link.download = filename
    link.click()
  }
}

function localLoadInterstialAds () {
  console.log('Loading interstial ads')
  window.localStorage.setItem(`${Constants.APP_STORAGE_KEY}-interstialReady`, false)
  if (window.cordova) {
    var options = {
      interstitialid: '931260990742693_1089942128207911',
      isTesting: false
    }
    window.cordova.plugins.codeplayfacebookads.loadInterstitialAds(options, interstitialSuccess, interstitialFail)
  }
  function interstitialSuccess (event) {
    console.log('Interstitial Ad load success', event)
    if (event === 'AdLoaded') {
      console.log('Ad loaded succesfully')
      window.localStorage.setItem(`${Constants.APP_STORAGE_KEY}-interstialReady`, true)
    } else if (event === 'AdClosed') {
      localLoadInterstialAds()
    } else if (event === 'AdImpression') {
      localSetAdShown()
    }
  }

  function interstitialFail (error) {
    console.log('Failed to load interstitialAd', error)
  }
}

function localSetAdShown () {
  window.localStorage.setItem(`${Constants.APP_STORAGE_KEY}-adShown`, new Date().getTime())
}



// WEBPACK FOOTER //
// ./src/common/CommonUtils.js